import { Injectable, Injector } from '@angular/core'
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle, Router } from '@angular/router'

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private router?: Router

  constructor(private injector: Injector) {}

  private getRouter(): Router {
    if (!this.router) {
      this.router = this.injector.get(Router)
    }
    return this.router
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null
  }

  /**
   * Returns if a route should be reused. By default, routes are reused for performance.
   * If shouldReuseRoute = false, route components are destroyed and recreated.
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const state = this.getRouter().currentNavigation()?.extras.state
    if (state && 'shouldReuseRoute' in state) return state.shouldReuseRoute

    // default reuse strategy if shouldReuseRoute not set
    return future.routeConfig === curr.routeConfig
  }
}
